
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
  },
  model: {
    prop: 'modelValue',
    event: 'change',
  }
})
export default class RadioButton extends Vue {
    // @Prop() value: any;
    @Prop({ default: '' }) modelValue: any;
    // @Prop({ type: Boolean, default: true }) trueValue: boolean;
    // @Prop({ type: Boolean, default: false }) falseValue: boolean;

    @Prop({ type: String, default: '' }) validation: string;
    @Prop({ type: String, default: '' }) form: string;
    @Prop({ type: String, default: '' }) name: string;
    @Prop({ type: String, required: false }) label: string;
    @Prop({ type: String, default: 'normal' }) size: string;
    @Prop({ type: String, default: 'primary' }) variant: string;
    @Prop({ type: Boolean, default: false }) disabled: boolean;
    @Prop({ type: Boolean, default: false }) loading: boolean;

    get classes() {
      return {
        'rb-primary': this.variant === 'primary',
        'rb-secondary': this.variant === 'secondary',
        normal: this.size === 'normal',
        [this.name]: true,
      }
    }

    get isChecked() {
      return this.modelValue === this.value
    }

    // updateInput() {
    //   this.$emit('change', this.value);
    // }

    get disenabled() {
      return this.loading || this.disabled;
    }

    get value() {
      return this.modelValue;
    }

    set value(value) {
      this.$emit('change', value);
    }
}
